export const currencyScale = currency => 2
